<template>
    <a href="#" v-bind:class="['btn', btnClass]" @click.prevent="onClicked">
      <i v-bind:class="[iconStyle, icon]" v-if="icon"></i> <slot />
    </a>
</template>

<script>
export default {
    name: 'ActionButton',
    props: {
      type: String
    },
    data() {
      return {
        buttonMap: {
          'new': { iconStyle: 'fas', icon: 'fa-plus', class: 'btn-primary' },
          'newLog': { iconStyle: 'fas', icon: 'fa-comment', class: 'btn-primary' },
          'delete': { iconStyle: 'fas', icon: 'fa-times', class: 'btn-danger' },
          'archive': { iconStyle: 'fas', icon: 'fa-archive', class: 'btn-warning' },
          'restore': { iconStyle: 'fas', icon: 'fa-undo', class: 'btn-success' },
          'edit': { iconStyle: 'fas', icon: 'fa-pencil', class: 'btn-default' },
          'cancel': { iconStyle: 'fas', icon: '', class: 'btn-default' },
          'approve': { iconStyle: 'fas', icon: 'fa-thumbs-up', class: 'btn-primary' },
          'date': { iconStyle: 'far', icon: 'fa-calendar', class: 'btn-default' },
          'print': { iconStyle: 'far', icon: 'fa-print', class: 'btn-default' },
          'scan': { iconStyle: 'far', icon: 'fa-scanner', class: 'btn-success' },
          'help': { iconStyle: 'far', icon: 'fa-question-circle', class: 'btn-default' },
          'view': { iconStyle: 'far', icon: 'fa-eye', class: 'btn-default' },
          'action': { iconStyle: 'far', icon: 'fa-tools', class: 'btn-primary' },
        }
      }
    },
    computed: {
      icon() {
        return this.buttonMap[this.type] ? this.buttonMap[this.type].icon : ''
      },
      iconStyle() {
        return this.buttonMap[this.type] ? this.buttonMap[this.type].iconStyle : 'fas'
      },
      btnClass() {
        return this.buttonMap[this.type] ? this.buttonMap[this.type].class : ''
      }

    },
    methods: {
      onClicked(evt) {
        this.$emit('click', evt)
      }
    }
}
</script>
